import React, { Fragment, useEffect, useState } from "react";
import PageHeader from "../../common/components/PageHeader";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import MentorListing from "./MentoringListing";
import { ServiceOffer } from "../../common/const";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { useDispatch } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getMentorList } from "../../api/mentorApi";
import theme from "../../theme";
import CommonCard from "../../common/components/CommonCard";

const InviteCounsellor = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const [mentors, setMentors] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 12;
    const searchParams = new URLSearchParams(location.search);

    // Extract all parameters
    const details = {
        type: searchParams.get('type'),
    };

    const getMentorData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getMentorList(currentPage, pageSize, JSON.stringify([{ "column": "service_offers", "op": "has", "value": ServiceOffer.counsellor }]), '', true);
            setMentors(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            setMentors(null);
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getMentorData();
    }, [currentPage]);

    return (
        <Fragment>
            <PageHeader
                title="Invite a Counselor"
                content={
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography color="text.secondary" sx={{ fontSize: 14, }}>
                            My Parent Account
                        </Typography>
                        <FiberManualRecord sx={{ fontSize: 8, color: 'text.secondary' }} />
                        <Typography color="text.secondary" sx={{ fontSize: 14, }}>
                            Invite a counsellor
                        </Typography>
                    </Stack>
                }
            />
            <Grid container spacing={1} mt={0.5}>
                <Grid item md={12}>
                    <CommonCard
                        borderRadius={2}
                        paddingBottom="0px"
                        marginTop="0px"
                        content={
                            <Box>
                                <Typography fontWeight={600} fontSize={18}>Choose Your Counselor</Typography>
                                <Typography fontSize={13} color={theme.palette.background.dark}>Find the perfect expert to guide your AI journey</Typography>
                            </Box>
                        }
                    />
                </Grid>
                <Grid item md={12}>
                    <MentorListing
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={mentors?.pagination?.totalPages}
                        itemsPerPage={pageSize}
                        mentors={mentors?.data}
                        details={details}
                    />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default InviteCounsellor;